'use client'

import React, {useContext, useEffect, useState} from "react";
import {AUTH_CHECK} from "@/components/providers/appContext/types";
import {usePathname} from "next/navigation";

export const SettingsContext = React.createContext<AUTH_CHECK | null>(null);

export const SettingsProvider = ({children}: { children: React.ReactNode }) => {
    const [loading, setLoading] = useState<boolean>(true);
    const pathName = usePathname();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true); // Mark as mounted after hydration
    }, []);

    useEffect(() => {
        setLoading(false);
    }, [pathName])

    const [appContext, setAppContext] = React.useState<AUTH_CHECK>({
        needLogin: false
    });

    if(!mounted) return null;

    return (
        <SettingsContext.Provider value={appContext}>
            {!loading ? children : ""}
        </SettingsContext.Provider>
    );

}

export const useSettingsContext = () => useContext(SettingsContext);